import { i18nInstance } from "@staccx/i18n"

export const getContactErrorMessage = (err) => {
  if(err.response && err.response.data){
    if (err.response.data.code) {
      return i18nInstance.translate(err.response.data.code)
    }
  }
  return err.message
}